import StoreAddressAutocompleteInput from "@/components/StoreComponents/StoreAddressAutocompleteInput";
import { CheckoutInputV2 } from "../../CheckoutInputV2";
import { InputContainer } from "../../InputContainer";

import { MOBILE_SCREEN_SIZE } from "@brandclub/common-ui";
import { styled } from "@mui/material";
import { AutocompleteAddress } from "../../CheckoutV2/CheckoutForm/components/CheckoutAddressAutocompleteInput";

const Container = styled("div")(({ theme }) => ({
  marginTop: 44,
  display: "flex",
  flexDirection: "column",
  gap: 12,
  [`@media screen and (max-width: ${MOBILE_SCREEN_SIZE}px)`]: {
    marginTop: 20,
  },
  ".title": {
    fontSize: 20,
    fontWeight: 600,

    [`@media screen and (max-width: ${MOBILE_SCREEN_SIZE}px)`]: {
      fontSize: 14,
    },
  },
}));

const AddressForm = ({
  firstName,
  setFirstName,
  lastName,
  setLastName,
  address1,
  setAddress1,
  address2,
  setAddress2,
  city,
  setCity,
  state,
  setState,
  zipCode,
  setZipCode,
  disabled = false,
}: {
  firstName?: string;
  setFirstName: (firstName: string) => void;
  lastName?: string;
  setLastName: (lastName: string) => void;
  address1?: string;
  setAddress1: (address1: string) => void;
  address2?: string;
  setAddress2: (address2: string) => void;
  city?: string;
  setCity: (city: string) => void;
  state?: string;
  setState: (state: string) => void;
  zipCode?: string;
  setZipCode: (zipCode: string) => void;
  disabled?: boolean;
}) => {
  return (
    <Container>
      <InputContainer>
        <CheckoutInputV2
          label={"First Name"}
          value={firstName}
          onChange={(e) => setFirstName(e.target.value)}
          disabled={disabled}
        />
        <CheckoutInputV2
          label={"Last Name"}
          value={lastName}
          onChange={(e) => setLastName(e.target.value)}
          disabled={disabled}
        />
      </InputContainer>
      <InputContainer>
        <StoreAddressAutocompleteInput
          searchTerm={address1 || ""}
          selectAddressCallback={(address: AutocompleteAddress) => {
            setAddress1(address?.line1 || "");
            setCity(address?.city || "");
            setState(address?.state || "");
            setZipCode(address?.zip || "");
          }}
          renderInput={(param: any) => (
            <CheckoutInputV2
              placeholder="Begin typing to search"
              label={"Street address"}
              value={address1}
              onChange={(e) => setAddress1(e.target.value)}
              disabled={disabled}
              {...param}
              InputProps={{
                ...param.InputProps,
              }}
              inputProps={{
                ...param.inputProps,
                value: address1,
              }}
            />
          )}
        />
      </InputContainer>
      <InputContainer>
        <CheckoutInputV2
          label={"Suite, Apartment, C/O"}
          value={address2}
          disabled={disabled}
          onChange={(e) => setAddress2(e.target.value)}
        />
        <CheckoutInputV2
          label={"City"}
          value={city}
          disabled={disabled}
          onChange={(e) => setCity(e.target.value)}
        />
      </InputContainer>
      <InputContainer>
        <CheckoutInputV2
          label={"State"}
          value={state}
          disabled={disabled}
          onChange={(e) => setState(e.target.value)}
        />
        <CheckoutInputV2
          label={"Zip Code"}
          value={zipCode}
          disabled={disabled}
          onChange={(e) => setZipCode(e.target.value)}
        />
      </InputContainer>
    </Container>
  );
};

export default AddressForm;
